// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Apps page. Reuses the Channels card grid + modal chrome (ChannelsPage.css);
   this file only adds the app-specific detail panel rendered inside the modal
   and the "Connected" card badge. */

/* The Apps modal hosts the ProviderHub (e.g. Wix data dimensions + preview
   tables), which needs more room than the shared 780px channel modal. Widen just
   this modal; the Channels modal keeps its default. Two classes outrank the base
   \`.channel-modal\` rule regardless of CSS import order, and \`max-width: 100%\`
   (inherited from \`.channel-modal\`) keeps it responsive on small screens. */
.channel-modal.channel-modal-apps {
  width: 1240px;
}

/* …except for a connected connection-only app (Wix / Shopify), whose body is now
   just the bound account plus one CTA. At 1240px that reads as a near-empty
   banner. Three classes outrank the two-class rule above. */
.channel-modal.channel-modal-apps.channel-modal-apps-narrow {
  width: 560px;
}

/* Close button copied 1:1 from chatModal's .chat-modal-close-btn (chatModal.css).
   Scoped to .channel-modal-apps so the Channels / credentials modals are unaffected.
   width/height:auto neutralises the base .channel-modal-close fixed box so it's
   padding-sized exactly like chatModal. */
.channel-modal-apps .channel-modal-close {
  width: auto;
  height: auto;
  background: none;
  border: none;
  font-size: 20px;
  color: #888;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
  line-height: 1;
}
.channel-modal-apps .channel-modal-close:hover {
  background: #f0f0f0;
  color: #333;
}

.apps-grid-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  color: #5616ea;
  font-size: 22px;
}

/* Green "Connected" pill in the card name (overrides the dark channel badge). */
.channel-card-badge.app-badge-connected {
  background: #e7f7ed;
  color: #1f9d57;
}

/* "Coming soon" card: not connectable yet (e.g. awaiting the provider's app
   approval). Visible but de-emphasised and non-interactive. */
.channel-card-badge.app-badge-soon {
  background: #f0eef6;
  color: #6b6486;
}

/* Automation-platform card (Zapier / Make / n8n): a skill reaches these through
   an http tool. Usable today, so the card stays ENABLED (no badge); its modal
   (WebhookAppInfo) explains it and hands off to the Studio build agent via a
   "Connect {platform}" CTA. */
.webhook-app-info { display: flex; flex-direction: column; gap: 14px; }
.webhook-app-summary { margin: 0; color: #4a4560; }
.webhook-app-block h4 {
  margin: 0 0 6px;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b6486;
}
.webhook-app-block ul { margin: 0; padding-left: 18px; color: #4a4560; }
.webhook-app-block li { margin: 4px 0; }
.webhook-app-hint { margin: 0; font-size: 0.9rem; color: #6b6486; }
.webhook-app-info .channels-help-btn { align-self: flex-start; }
.channel-card.channel-card-soon {
  opacity: 0.6;
  cursor: default;
}
.channel-card.channel-card-soon:hover {
  transform: none;
}
.channel-card.channel-card-soon .channel-card-cta {
  color: #9a93b3;
}

/* Empty state when a filter (e.g. Connected) matches no apps. */
.apps-filter-empty {
  margin: 8px 2px;
  font-size: 14px;
  color: #82828e;
}

/* ── Detail panel (modal body) ─────────────────────────────────────── */
.app-detail {
  font-family: "DM Sans", sans-serif;
  color: #2b2b35;
  /* The modal's morph wrapper (.channel-modal-morph) is overflow:hidden and sized
     to this panel's exact measured height, so a bottom element sitting flush with
     the edge — the ghost "Manage connection" button's 1px border — gets clipped.
     A little bottom padding is included in that measurement, keeping the button
     (and its full border) inside the visible area. */
  padding-bottom: 4px;
}
.app-detail-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  font-size: 22px;
}
.app-detail-summary {
  margin: 0 0 18px;
  font-size: 14px;
  line-height: 1.55;
  color: #4a4a55;
}

.app-detail-caps {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 18px;
}
@media (max-width: 560px) {
  .app-detail-caps {
    grid-template-columns: 1fr;
  }
}
.app-cap {
  border: 1px solid #ececf1;
  border-radius: 10px;
  padding: 12px 14px;
}
.app-cap-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}
.app-cap-can {
  color: #1f9d57;
}
.app-cap-cannot {
  color: #b4453c;
}
.app-cap ul {
  margin: 0;
  padding-left: 18px;
}
.app-cap li {
  font-size: 12.5px;
  line-height: 1.5;
  color: #5a5a66;
  margin-bottom: 4px;
}
.app-cap li:last-child {
  margin-bottom: 0;
}

.app-detail-connected {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1f9d57;
  background: #e7f7ed;
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 14px;
}

.app-detail-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.app-btn {
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 18px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}
.app-btn-primary {
  background: #5616ea;
  color: #fff;
}
.app-btn-primary:hover {
  background: #4a14d6;
  transform: translateY(-1px);
}
.app-btn-ghost {
  background: #fff;
  color: #5616ea;
  border-color: #d8caf7;
}
.app-btn-ghost:hover {
  background: #f3eaff;
  border-color: #5616ea;
}

/* Workspace API-credentials launcher in the Apps header (opens CredentialsManager). */
.apps-credentials-btn {
  margin-top: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  color: #5616ea;
  border: 1px solid #e6e0f5;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}
.apps-credentials-btn:hover { border-color: #c4b5fd; background: #faf8ff; }

/* ── Connection-only app panel (Wix / Shopify once connected) ──────────
   Two questions, in order: what is bound, and where do I go next. No delete
   button — a platform install is uninstalled on the platform, which is also what
   ends the billing. Row grammar matches the Knowledge Base provider page so the
   two surfaces read as one system. */
.apps-conn {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* Identity: the bound account is the headline, the status a quiet confirmation. */
.apps-conn-identity {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 4px 2px 18px;
  border-bottom: 1px solid #f2eefa;
}

.apps-conn-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #ece7f6;
}
.apps-conn-mark img { max-width: 24px; max-height: 24px; object-fit: contain; }

.apps-conn-account {
  min-width: 0;
  font-size: 1.02rem;
  font-weight: 700;
  color: #241b3d;
  letter-spacing: -0.01em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.apps-conn-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-left: auto;
  flex-shrink: 0;
  padding: 4px 11px;
  border-radius: 999px;
  background: #e8f6ee;
  color: #1f8a4c;
  font-size: 0.74rem;
  font-weight: 600;
}
.apps-conn-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #1f8a4c;
}

/* Actions: full-width rows, not buttons in a toolbar. The primary one is tinted
   rather than filled — a solid purple bar at this width shouted louder than the
   account name it sits under. */
.apps-conn-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.apps-conn-action {
  display: flex;
  align-items: center;
  gap: 13px;
  width: 100%;
  padding: 14px 15px;
  text-align: left;
  background: #fff;
  border: 1px solid #ece7f6;
  border-radius: 14px;
  cursor: pointer;
  font-family: "DM Sans", sans-serif;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}
.apps-conn-action:hover:not(:disabled) {
  border-color: #c9b9fb;
  background: #faf8ff;
}
.apps-conn-action:disabled { cursor: default; opacity: 0.55; }

.apps-conn-action-primary {
  background: #f8f5ff;
  border-color: #ddd0fd;
}
.apps-conn-action-primary:hover:not(:disabled) {
  border-color: #b9a3fa;
  background: #f4efff;
}

.apps-conn-action-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #f1ecff;
  color: #5616ea;
  font-size: 0.85rem;
}
.apps-conn-action-primary .apps-conn-action-icon {
  background: linear-gradient(135deg, #5616ea, #7a3cff);
  color: #fff;
}

.apps-conn-action-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.apps-conn-action-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #241b3d;
}
.apps-conn-action-sub {
  font-size: 0.77rem;
  line-height: 1.4;
  color: #7b7497;
}

.apps-conn-action-go {
  margin-left: auto;
  flex-shrink: 0;
  color: #cec7e2;
  font-size: 0.75rem;
  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), color 0.2s ease;
  will-change: transform;
}
.apps-conn-action:hover:not(:disabled) .apps-conn-action-go {
  color: #5616ea;
  transform: translateX(3px);
}

.apps-wix-explore { display: flex; flex-direction: column; gap: 18px; min-width: 0; }
.apps-conn-wix .apps-conn-action { padding: 20px; border-radius: 16px; }
.apps-conn-wix .apps-conn-action-icon { width: 42px; height: 42px; border-radius: 12px; }
.apps-conn-wix .apps-wix-capabilities-action .apps-conn-action-icon { background: #ede5ff; color: #6726ef; }
.apps-conn-wix .apps-conn-action-sub { margin-top: 4px; line-height: 1.5; }
@media (max-width: 600px) {
  .apps-conn-wix .apps-conn-action { padding: 16px 12px; gap: 10px; }
  .apps-conn-wix .apps-conn-action-icon { width: 34px; height: 34px; }
}

.channel-modal.channel-modal-apps.channel-modal-wix { width: 720px; }
.channel-modal-wix .channel-modal-body { max-height: calc(100dvh - 160px); }
`, "",{"version":3,"sources":["webpack://./src/pages/AppsPage.css"],"names":[],"mappings":"AAAA;;oCAEoC;;AAEpC;;;;4EAI4E;AAC5E;EACE,aAAa;AACf;;AAEA;;4DAE4D;AAC5D;EACE,YAAY;AACd;;AAEA;;;0CAG0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;8DAC8D;AAC9D;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;8BAG8B;AAC9B,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACtE,uBAAuB,SAAS,EAAE,cAAc,EAAE;AAClD;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA,wBAAwB,SAAS,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACvE,wBAAwB,aAAa,EAAE;AACvC,oBAAoB,SAAS,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAClE,uCAAuC,sBAAsB,EAAE;AAC/D;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,kCAAkC;EAClC,cAAc;EACd;;;;qDAImD;EACnD,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,6EAA6E;AAC/E;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sFAAsF;AACtF;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE;;AAE1E;;;;qCAIqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE9E;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;gCAEgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,8DAA8D;AAChE;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA,6BAA6B,eAAe,EAAE,aAAa,EAAE;;AAE7D;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,0EAA0E;EAC1E,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,YAAY,EAAE;AACpF,mCAAmC,aAAa,EAAE,mBAAmB,EAAE;AACvE,wCAAwC,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACxF,sEAAsE,mBAAmB,EAAE,cAAc,EAAE;AAC3G,uCAAuC,eAAe,EAAE,gBAAgB,EAAE;AAC1E;EACE,mCAAmC,kBAAkB,EAAE,SAAS,EAAE;EAClE,wCAAwC,WAAW,EAAE,YAAY,EAAE;AACrE;;AAEA,sDAAsD,YAAY,EAAE;AACpE,yCAAyC,gCAAgC,EAAE","sourcesContent":["/* Apps page. Reuses the Channels card grid + modal chrome (ChannelsPage.css);\r\n   this file only adds the app-specific detail panel rendered inside the modal\r\n   and the \"Connected\" card badge. */\r\n\r\n/* The Apps modal hosts the ProviderHub (e.g. Wix data dimensions + preview\r\n   tables), which needs more room than the shared 780px channel modal. Widen just\r\n   this modal; the Channels modal keeps its default. Two classes outrank the base\r\n   `.channel-modal` rule regardless of CSS import order, and `max-width: 100%`\r\n   (inherited from `.channel-modal`) keeps it responsive on small screens. */\r\n.channel-modal.channel-modal-apps {\r\n  width: 1240px;\r\n}\r\n\r\n/* …except for a connected connection-only app (Wix / Shopify), whose body is now\r\n   just the bound account plus one CTA. At 1240px that reads as a near-empty\r\n   banner. Three classes outrank the two-class rule above. */\r\n.channel-modal.channel-modal-apps.channel-modal-apps-narrow {\r\n  width: 560px;\r\n}\r\n\r\n/* Close button copied 1:1 from chatModal's .chat-modal-close-btn (chatModal.css).\r\n   Scoped to .channel-modal-apps so the Channels / credentials modals are unaffected.\r\n   width/height:auto neutralises the base .channel-modal-close fixed box so it's\r\n   padding-sized exactly like chatModal. */\r\n.channel-modal-apps .channel-modal-close {\r\n  width: auto;\r\n  height: auto;\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n  color: #888;\r\n  cursor: pointer;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n  transition: all 0.2s ease;\r\n  line-height: 1;\r\n}\r\n.channel-modal-apps .channel-modal-close:hover {\r\n  background: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.apps-grid-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px;\r\n  color: #5616ea;\r\n  font-size: 22px;\r\n}\r\n\r\n/* Green \"Connected\" pill in the card name (overrides the dark channel badge). */\r\n.channel-card-badge.app-badge-connected {\r\n  background: #e7f7ed;\r\n  color: #1f9d57;\r\n}\r\n\r\n/* \"Coming soon\" card: not connectable yet (e.g. awaiting the provider's app\r\n   approval). Visible but de-emphasised and non-interactive. */\r\n.channel-card-badge.app-badge-soon {\r\n  background: #f0eef6;\r\n  color: #6b6486;\r\n}\r\n\r\n/* Automation-platform card (Zapier / Make / n8n): a skill reaches these through\r\n   an http tool. Usable today, so the card stays ENABLED (no badge); its modal\r\n   (WebhookAppInfo) explains it and hands off to the Studio build agent via a\r\n   \"Connect {platform}\" CTA. */\r\n.webhook-app-info { display: flex; flex-direction: column; gap: 14px; }\r\n.webhook-app-summary { margin: 0; color: #4a4560; }\r\n.webhook-app-block h4 {\r\n  margin: 0 0 6px;\r\n  font-size: 0.85rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: #6b6486;\r\n}\r\n.webhook-app-block ul { margin: 0; padding-left: 18px; color: #4a4560; }\r\n.webhook-app-block li { margin: 4px 0; }\r\n.webhook-app-hint { margin: 0; font-size: 0.9rem; color: #6b6486; }\r\n.webhook-app-info .channels-help-btn { align-self: flex-start; }\r\n.channel-card.channel-card-soon {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n.channel-card.channel-card-soon:hover {\r\n  transform: none;\r\n}\r\n.channel-card.channel-card-soon .channel-card-cta {\r\n  color: #9a93b3;\r\n}\r\n\r\n/* Empty state when a filter (e.g. Connected) matches no apps. */\r\n.apps-filter-empty {\r\n  margin: 8px 2px;\r\n  font-size: 14px;\r\n  color: #82828e;\r\n}\r\n\r\n/* ── Detail panel (modal body) ─────────────────────────────────────── */\r\n.app-detail {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  color: #2b2b35;\r\n  /* The modal's morph wrapper (.channel-modal-morph) is overflow:hidden and sized\r\n     to this panel's exact measured height, so a bottom element sitting flush with\r\n     the edge — the ghost \"Manage connection\" button's 1px border — gets clipped.\r\n     A little bottom padding is included in that measurement, keeping the button\r\n     (and its full border) inside the visible area. */\r\n  padding-bottom: 4px;\r\n}\r\n.app-detail-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px;\r\n  font-size: 22px;\r\n}\r\n.app-detail-summary {\r\n  margin: 0 0 18px;\r\n  font-size: 14px;\r\n  line-height: 1.55;\r\n  color: #4a4a55;\r\n}\r\n\r\n.app-detail-caps {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 14px;\r\n  margin-bottom: 18px;\r\n}\r\n@media (max-width: 560px) {\r\n  .app-detail-caps {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n.app-cap {\r\n  border: 1px solid #ececf1;\r\n  border-radius: 10px;\r\n  padding: 12px 14px;\r\n}\r\n.app-cap-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  margin-bottom: 8px;\r\n}\r\n.app-cap-can {\r\n  color: #1f9d57;\r\n}\r\n.app-cap-cannot {\r\n  color: #b4453c;\r\n}\r\n.app-cap ul {\r\n  margin: 0;\r\n  padding-left: 18px;\r\n}\r\n.app-cap li {\r\n  font-size: 12.5px;\r\n  line-height: 1.5;\r\n  color: #5a5a66;\r\n  margin-bottom: 4px;\r\n}\r\n.app-cap li:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.app-detail-connected {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #1f9d57;\r\n  background: #e7f7ed;\r\n  border-radius: 8px;\r\n  padding: 8px 12px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.app-detail-buttons {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n.app-btn {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  border-radius: 8px;\r\n  padding: 10px 18px;\r\n  cursor: pointer;\r\n  border: 1px solid transparent;\r\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;\r\n}\r\n.app-btn-primary {\r\n  background: #5616ea;\r\n  color: #fff;\r\n}\r\n.app-btn-primary:hover {\r\n  background: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n.app-btn-ghost {\r\n  background: #fff;\r\n  color: #5616ea;\r\n  border-color: #d8caf7;\r\n}\r\n.app-btn-ghost:hover {\r\n  background: #f3eaff;\r\n  border-color: #5616ea;\r\n}\r\n\r\n/* Workspace API-credentials launcher in the Apps header (opens CredentialsManager). */\r\n.apps-credentials-btn {\r\n  margin-top: 12px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: #fff;\r\n  color: #5616ea;\r\n  border: 1px solid #e6e0f5;\r\n  border-radius: 8px;\r\n  padding: 8px 14px;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n.apps-credentials-btn:hover { border-color: #c4b5fd; background: #faf8ff; }\r\n\r\n/* ── Connection-only app panel (Wix / Shopify once connected) ──────────\r\n   Two questions, in order: what is bound, and where do I go next. No delete\r\n   button — a platform install is uninstalled on the platform, which is also what\r\n   ends the billing. Row grammar matches the Knowledge Base provider page so the\r\n   two surfaces read as one system. */\r\n.apps-conn {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n}\r\n\r\n/* Identity: the bound account is the headline, the status a quiet confirmation. */\r\n.apps-conn-identity {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 13px;\r\n  padding: 4px 2px 18px;\r\n  border-bottom: 1px solid #f2eefa;\r\n}\r\n\r\n.apps-conn-mark {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 42px;\r\n  height: 42px;\r\n  flex-shrink: 0;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  border: 1px solid #ece7f6;\r\n}\r\n.apps-conn-mark img { max-width: 24px; max-height: 24px; object-fit: contain; }\r\n\r\n.apps-conn-account {\r\n  min-width: 0;\r\n  font-size: 1.02rem;\r\n  font-weight: 700;\r\n  color: #241b3d;\r\n  letter-spacing: -0.01em;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.apps-conn-status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n  padding: 4px 11px;\r\n  border-radius: 999px;\r\n  background: #e8f6ee;\r\n  color: #1f8a4c;\r\n  font-size: 0.74rem;\r\n  font-weight: 600;\r\n}\r\n.apps-conn-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: #1f8a4c;\r\n}\r\n\r\n/* Actions: full-width rows, not buttons in a toolbar. The primary one is tinted\r\n   rather than filled — a solid purple bar at this width shouted louder than the\r\n   account name it sits under. */\r\n.apps-conn-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.apps-conn-action {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 13px;\r\n  width: 100%;\r\n  padding: 14px 15px;\r\n  text-align: left;\r\n  background: #fff;\r\n  border: 1px solid #ece7f6;\r\n  border-radius: 14px;\r\n  cursor: pointer;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  transition: border-color 0.2s ease, background-color 0.2s ease;\r\n}\r\n.apps-conn-action:hover:not(:disabled) {\r\n  border-color: #c9b9fb;\r\n  background: #faf8ff;\r\n}\r\n.apps-conn-action:disabled { cursor: default; opacity: 0.55; }\r\n\r\n.apps-conn-action-primary {\r\n  background: #f8f5ff;\r\n  border-color: #ddd0fd;\r\n}\r\n.apps-conn-action-primary:hover:not(:disabled) {\r\n  border-color: #b9a3fa;\r\n  background: #f4efff;\r\n}\r\n\r\n.apps-conn-action-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 34px;\r\n  height: 34px;\r\n  flex-shrink: 0;\r\n  border-radius: 10px;\r\n  background: #f1ecff;\r\n  color: #5616ea;\r\n  font-size: 0.85rem;\r\n}\r\n.apps-conn-action-primary .apps-conn-action-icon {\r\n  background: linear-gradient(135deg, #5616ea, #7a3cff);\r\n  color: #fff;\r\n}\r\n\r\n.apps-conn-action-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  min-width: 0;\r\n}\r\n.apps-conn-action-title {\r\n  font-size: 0.875rem;\r\n  font-weight: 700;\r\n  color: #241b3d;\r\n}\r\n.apps-conn-action-sub {\r\n  font-size: 0.77rem;\r\n  line-height: 1.4;\r\n  color: #7b7497;\r\n}\r\n\r\n.apps-conn-action-go {\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n  color: #cec7e2;\r\n  font-size: 0.75rem;\r\n  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), color 0.2s ease;\r\n  will-change: transform;\r\n}\r\n.apps-conn-action:hover:not(:disabled) .apps-conn-action-go {\r\n  color: #5616ea;\r\n  transform: translateX(3px);\r\n}\r\n\r\n.apps-wix-explore { display: flex; flex-direction: column; gap: 18px; min-width: 0; }\r\n.apps-conn-wix .apps-conn-action { padding: 20px; border-radius: 16px; }\r\n.apps-conn-wix .apps-conn-action-icon { width: 42px; height: 42px; border-radius: 12px; }\r\n.apps-conn-wix .apps-wix-capabilities-action .apps-conn-action-icon { background: #ede5ff; color: #6726ef; }\r\n.apps-conn-wix .apps-conn-action-sub { margin-top: 4px; line-height: 1.5; }\r\n@media (max-width: 600px) {\r\n  .apps-conn-wix .apps-conn-action { padding: 16px 12px; gap: 10px; }\r\n  .apps-conn-wix .apps-conn-action-icon { width: 34px; height: 34px; }\r\n}\r\n\r\n.channel-modal.channel-modal-apps.channel-modal-wix { width: 720px; }\r\n.channel-modal-wix .channel-modal-body { max-height: calc(100dvh - 160px); }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
